<template>
    <v-dialog
        v-model="addResponseCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="modelType==='Add'"
                class="ma-1 action-btn text-subtitle-2"
                depressed
                color="primary"
                v-bind="attrs"
                @click="openDialog"
            >
                <v-icon
                    left
                    class="action-icon"
                >
                    mdi-plus
                </v-icon>
                Add Response Code
            </v-btn>
            <v-icon
                v-if="modelType==='Edit'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-pencil
            </v-icon>
        </template>
        <v-card id="add_response_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span v-if="modelType === 'Add'">Add Response Code</span>
                <span v-if="modelType === 'Edit'">Edit Response Code</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="formValid"
                > 
                    <v-row class="mt-5">
                        <v-col 
                            cols="12"
                            sm="12"
                            class="py-0"
                        >
                            <v-card
                                flat
                                color="#F5F7FA"
                            >
                                <v-list-item three-line>
                                    <v-list-item-content class="rule-list pt-2">
                                        <div class="sub-heading-title mb-2 instructions">
                                            Response code may include:
                                        </div>
                                        <v-list-item-title class="content">
                                            <ul>
                                                <li
                                                    v-for="rule of rules"
                                                    :key="rule.description"
                                                    class="rule-description"
                                                    :class="[ !response_code ? '' : rule.test(response_code) ? 'rule-passed' : 'rule-failed' ]"
                                                >
                                                    {{ rule.description }}
                                                </li>
                                            </ul>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            class="pb-0"
                        >
                            <v-text-field
                                v-if="addResponseCodeDialog"
                                v-model="response_code"
                                label="Code"
                                outlined
                                dense
                                class="upper-case"
                                :rules="ruleTests"
                                required
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-textarea
                                v-if="addResponseCodeDialog"
                                v-model="description"
                                outlined
                                auto-grow
                                name="Description"
                                label="Description"
                                row-height="15"
                                :rules="descriptionRules"
                                required
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="12"
                            class="py-0 checkbox-containner"
                        >
                            <v-checkbox
                                v-model="completes"
                                label="Closes Ticket"
                                class="py-0 my-0"
                            />
                            <v-checkbox
                                v-model="design"
                                label="For Design Ticket Only"
                                class="py-0 my-0"
                            />
                            <v-checkbox
                                v-model="send_pr_center"
                                label="Send +Response to Center"
                                class="py-0 my-0"
                            />
                            <v-checkbox
                                v-if="hasExcavatorResponse"
                                v-model="send_pr_excavator"
                                label="Send +Response to Excavator"
                                class="py-0 my-0"
                            />
                        </v-col>
                        <v-col
                            v-if="hasExcavatorResponse"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-textarea
                                v-if="send_pr_excavator"
                                v-model="pr_excavator_text"
                                outlined
                                auto-grow
                                name="+Response Excavator Text"
                                label="+Response Excavator Text"
                                row-height="15"
                                required
                            />
                        </v-col>
                        <v-col
                            v-if="hasIVRExcavatorResponse"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-textarea
                                v-if="send_pr_excavator"
                                v-model="pr_excavator_voice"
                                outlined
                                auto-grow
                                name="+Response Excavator Voice"
                                label="+Response Excavator Voice"
                                row-height="15"
                                required
                            />
                        </v-col>
                    </v-row>
                    <v-divider class="my-4" />
                    <div class="facility_types pb-3">
                        +Response Mapping
                    </div>
                    <v-col
                        v-for="item in companyCenters"
                        :key="item.state+item.center_id"
                        cols="12"
                        md="12"
                        class="px-0 py-0"
                    >
                        <div class="pb-3 text-color-black-gray">
                            {{ item.center_abbrev }} ({{ item.state }})
                        </div>
                        <v-select
                            v-model="posresp[item.state+item.center_id]"
                            :rules="posrespRules"
                            outlined
                            dense
                            :items="centersPosRespCodes[item.state+item.center_id]"
                            label="Response Code"
                            item-text="name"
                            item-value="value"
                        >
                            <template v-slot:[`item.name`]>
                                <div class="response-select-item">
                                    {{ item.name }}
                                </div>
                            </template>
                        </v-select>
                    </v-col>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <DeleteResponseCode
                    v-if="modelType==='Edit'" 
                    model-type="DeleteBtn"
                    :response-code="responseDetails"
                    @closed-dialog="closedDialog"
                />
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :disabled="!formValid"
                    @click="save"
                >
                    <span v-if="modelType==='Add'">Add</span>
                    <span v-if="modelType==='Edit'">Update</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>

import _ from 'lodash';
import webtmsBackend from '@/services/webtmsBackend';
import { hasPermission } from '../../../utils/permissions';
import DeleteResponseCode from './DeleteResponseCode';

export default {
    name: 'AddResponseCode',
    components: {
        DeleteResponseCode
    },
    props: {
        modelType: {
            type: String,
            required: true
        },
        responseDetails: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    data: () => ({
        response_code: '',
        description: '',
        descriptionRules: [
            v => !!v || 'Description is required',
        ],
        completes: true,
        design: false,
        send_pr_center: false,
        send_pr_excavator: false,
        pr_excavator_text: '',
        pr_excavator_voice: '',
        posresp: {},
        posrespRules: [
            v => !!v || `Please select +Response codes for each center`,
        ],
        formValid: false,
        addResponseCodeDialog: false,
    }),
    computed: {
        rules() {
            return [
                {
                    description: '1-16 characters',
                    test: (responseCode) => (responseCode?.length >= 1 && responseCode?.length <= 16),
                },
                {
                    description: 'Special characters - / .',
                    test: (responseCode) => /^[ A-Za-z0-9-/.]*$/.test(responseCode),
                },
            ];
        },
        ruleTests() {
            let ruleTestArray = [];
            if(!this.isEditUser) {
                this.rules.forEach(rule => {
                    ruleTestArray.push(rule.test);
                });
            }
            return ruleTestArray;
        },
        companyCenters() {
            let centers = [];
            if(this.$store.getters.companyCenters) {
                this.$store.getters.companyCenters.map(companyCenter => {
                    if(this.$store.getters.centers && companyCenter.uses_mapping && companyCenter.uses_posresp) {
                        this.$store.getters.centers.map((curr) => {
                            if(curr.center_id === companyCenter.center_id) {
                                curr.states.map(state => {
                                    centers.push({
                                        ...curr,
                                        state: state
                                    });
                                });
                            }
                        });
                    }
                });
            }
            return centers;
        },
        getcompanyPositiveResponseMap() {
            return this.$store.getters.companyPositiveResponseMap;
        },
        centersPosRespCodes() {
            let responseCodes = [...this.$store.getters.centersPosRespCodes];
            if(responseCodes) {
                return responseCodes.reduce((acc, curr) => {
                    if(!acc[curr.state+curr.center_id]) {
                        acc[curr.state+curr.center_id] = [];
                    }
                    acc[curr.state+curr.center_id].push({
                        name: curr.code !== '---' ? (curr.code + ' - ' + curr.description) : curr.description,
                        value: { positive_response_code: curr.code, center_id: curr.center_id, state: curr.state }
                    });
                    return acc;
                }, {});
            } else {
                return {};
            }
        },
        hasSMSExcavatorResponse() {
            return hasPermission('EXCAVATOR_RESPONSE--SMS');
        },
        hasIVRExcavatorResponse() {
            return hasPermission('EXCAVATOR_RESPONSE--IVR');
        },
        hasExcavatorResponse() {
            return hasPermission('EXCAVATOR_RESPONSE');
        },
    },
    methods: {
        resetFormData() {
            this.response_code = '';
            this.description = '';
            this.completes = true;
            this.design = false;
            this.send_pr_center = false;
            this.send_pr_excavator = false;
            this.pr_excavator_text = '';
            this.pr_excavator_voice = '';
            this.posresp = {};
            this.formValid = false;

            this.companyCenters.map((item) => {
                if(item) {
                    this.posresp[item.state+item.center_id] = null;
                }

                if(this.responseDetails) {
                    this.response_code = this.responseDetails.response_code;
                    this.description = this.responseDetails.description;
                    this.completes = this.responseDetails.completes;
                    this.design = this.responseDetails.design;
                    this.send_pr_center = this.responseDetails.send_pr_center;
                    this.send_pr_excavator = this.responseDetails.send_pr_excavator;
                    this.pr_excavator_text = this.responseDetails.pr_excavator_text;
                    this.pr_excavator_voice = this.responseDetails.pr_excavator_voice;

                    let data = this.getcompanyPositiveResponseMap.filter(item => {
                        return item.response_code == this.response_code;
                    });
                    this.posresp = data.reduce((acc, curr) => {
                        acc[curr.state+curr.center_id] = {
                            positive_response_code: curr.positive_response_code, 
                            center_id: curr.center_id, 
                            state: curr.state
                        };
                        return acc;
                    }, {});
                }
            });
        },
        capitalized(title) {
            return _.capitalize(title);
        },
        closedDialog() {
            this.resetFormData();
            this.addResponseCodeDialog = false;
        },
        openDialog() {
            this.resetFormData();
            this.addResponseCodeDialog = true;
        },
        async save() {
            console.log('this.completes:', this.completes); // eslint-disable-line no-console
            let data = {
                response_code: this.response_code.toUpperCase(),
                description: this.description,               
                completes: this.completes? true : false,
                design: this.design ? true : false,
                send_pr_center: this.send_pr_center ? true : false,
                send_pr_excavator: this.send_pr_excavator ? true : false,
                pr_excavator_text: this.pr_excavator_text,
                pr_excavator_voice: this.pr_excavator_voice,
                posresp: Object.values(this.posresp)
            };
            if(this.modelType === 'Add') {
                data.operation = 'insert';
                let result = await webtmsBackend.addResponseCode({ ...data });
                if(result.result === 'OK') {
                    this.$store.commit('SET_COMPANY_RESPONSE_CODES', result.companyResponseCodes);
                    this.$store.commit('SET_COMPANY_RESPONSE_MAP', result.companyPositiveResponseMap);
                    this.$store.dispatch('setSnackbar', { text: 'Response code added successfully!' });
                    this.closedDialog();
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } else {
                data.operation = 'update';
                let result = await webtmsBackend.editResponseCode({ ...data });
                if(result.result === 'OK') {
                    this.$store.commit('SET_COMPANY_RESPONSE_CODES', result.companyResponseCodes);
                    this.$store.commit('SET_COMPANY_RESPONSE_MAP', result.companyPositiveResponseMap);
                    this.$store.dispatch('setSnackbar', { text: 'Response code udpated successfully!' });
                    this.closedDialog();
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            }
        }
    }
};
</script>
<style>
    #add_response_code_dialog .v-input--selection-controls__input {
        height: 16px;
        width: 16px;
    }
    .text-color-black-gray { 
        color: #35383F;
        font-weight: 500;
        font-size: 14px;
    }
    .checkbox-containner .v-label {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
    }
    .checkbox-containner .v-input__slot {
        margin: 0px;
    }
    .facility_types {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #35383F;
    }
    .upper-case input, .upper-case textarea {
        text-transform: uppercase;
    }
    .rule-list {
        background: #F5F7FA;
        border-radius: 4px;
        color: #35383F;
        font-style: normal;
    }
    .instructions {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
    }
    .rule-description {
        font-weight: normal;
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0.004em;
    }
    .rule-passed {
        color: #2FA84F;
    }
    .rule-failed {
        color: #CB3D31;
    }
    .response-select-item {
        max-width: 410px;
        padding-bottom: 8px;
    }
</style>